// eslint-disable-next-line no-restricted-imports
import originalAxios from "axios";
const axios = originalAxios.create({
  baseURL: "/api/v0/",
  withCredentials: true,
  headers: {
    common: {
      Accept: "application/json",
    },
  },
});

export default axios;
